import { useEffect, useState } from 'react';
import { Alert, Spin, Space, Card, Statistic, Row, Col } from 'antd';
import axios from 'axios';

const TemplateImportExecution = ({
    accounts,
    associatedAccounts,
    formulas,
    onResult,
}) => {
    const [state, setState] = useState({
        status: 'idle',
        summary: null,
        error: null,
    });

    useEffect(() => {
        let cancelled = false;

        setState({
            status: 'loading',
            summary: null,
            error: null,
        });

        axios
            .post('/import/template/execute', {
                accounts,
                associatedAccounts,
                formulas,
            })
            .then((res) => {
                if (cancelled) return;

                if (res.data?.success) {
                    setState({
                        status: 'done',
                        summary: res.data.summary,
                        error: null,
                    });

                   onResult(true, res.data);
                } else {
                    setState({
                        status: 'error',
                        summary: null,
                        error: res.data?.error || 'Import failed',
                    });

                    onResult(false);
                }
            })
            .catch((err) => {
                if (cancelled) return;

                setState({
                    status: 'error',
                    summary: null,
                    error:
                        err?.response?.data?.error ||
                        err.message ||
                        'Import failed',
                });

                onResult(false);
            });

        return () => {
            cancelled = true;
        };
    }, [accounts, associatedAccounts, formulas, onResult]);

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            {state.status === 'loading' && (
                <Alert
                    type="info"
                    message={<Spin size="small" />}
                    description="Importing account structure..."
                />
            )}

            {state.status === 'error' && (
                <Alert
                    type="error"
                    showIcon
                    message="Import failed"
                    description={state.error}
                />
            )}

            {state.status === 'done' && (
                <>
                    <Alert
                        type="success"
                        showIcon
                        message="Import complete"
                    />

                    <Card size="small">
                        <Row gutter={16}>
                            <Col span={8}>
                                <Statistic
                                    title="Accounts"
                                    value={state.summary.accountsInserted}
                                />
                            </Col>

                            <Col span={8}>
                                <Statistic
                                    title="Associated Accounts"
                                    value={state.summary.associatedAccountsInserted}
                                />
                            </Col>

                            <Col span={8}>
                                <Statistic
                                    title="Formulas"
                                    value={state.summary.formulasInserted}
                                />
                            </Col>
                        </Row>
                    </Card>
                </>
            )}
        </Space>
    );
};

export default TemplateImportExecution;